export enum DefaultImages {
  PRODUCTION_SITE = 'assets/images/default-production-site-image.png'
}
